// getRegistration() settles without a service worker, where serviceWorker.ready would wait forever
const browserHoldsPushSubscription = async () => {
  try {
    if ((typeof Notification === 'undefined') || (Notification.permission !== 'granted')) return false;

    const registration = await navigator.serviceWorker?.getRegistration();
    const subscription = await registration?.pushManager?.getSubscription();
    return Boolean(subscription);
  } catch {
    return false;
  }
};

export default browserHoldsPushSubscription;
